import { getUserPending, getUserSuccess, getUserFail } from "./userSlice";
import { fetchUser, fetchBasicUsers } from "../../api/userApi";

export const getUserProfile = () => async (dispatch) => {
  try {
    dispatch(getUserPending());

    const result = await fetchUser();

    if (result.user && result.user._id)
      return dispatch(getUserSuccess(result.user));

    dispatch(getUserFail("User is not found"));
  } catch (error) {
    dispatch(getUserFail(error));
  }
};

export const getAllUsers = () => async () => {
  try {
    //dispatch(getUserPending());

    const result = await fetchBasicUsers();
console.log(result);
    //if (result.user && result.user._id)
      return result;

    //dispatch(getUserFail("User is not found"));
  } catch (error) {
    console.log(error);
   // dispatch(getUserFail(error));
  }
};